import firebase from 'firebase/app'
import { create } from '@mizz/penny-core/entities/budget'
import { useEmulator } from '../config'

const db = firebase.firestore()

if (useEmulator) {
  db.useEmulator('localhost', 5005)
}

export async function getByYearAndMonth(year, month, userId) {
  const createEmpty = () => ({...create(), year, month })

  try {
    const yearRef = await db.doc(`users/${userId}/budgets/${year}`).get()

    if (!yearRef.exists) {
      return createEmpty()
    }

    const budgetRef = yearRef.data()[month]

    if (!budgetRef) {
      return createEmpty()
    }

    const budget = await budgetRef.get()
    const items = await budgetRef.collection('items').orderBy('day', 'desc').get()

    return {
      ...budget.data(),
      items: items.docs.map((doc) => {
        const { amount, date, description, category, type } = doc.data()

        return {
          id: doc.id,
          amount,
          date,
          description,
          category,
          type
        }
      })
    }

  } catch (err) {
    console.error(err)
  }

  return createEmpty()
}
